module.exports = __webpack_public_path__ + "img/transgender-inactive.f49ed55f.svg";